export default function (Component) {
      Component.options.$frontmatter = {"layout":"@/components/layout/MarkdownView.vue","title":"Privacy Policy","author":"Admin","date":"2020-07-18T23:13:28.195Z"};
    }